export default "__VITE_ASSET__zmiautRJ__"